import cn from 'bem-cn';

import { useSearch } from '../../store';
import { Search } from '../UI';

import './HomePageSearch.scss';

const b = cn('home-page-search');

export const HomePageSearch = () => {
    const { searchQuery, handleSearch } = useSearch();

    return (
        <Search
            className={b()}
            value={searchQuery}
            onSearch={handleSearch}
            placeholder="Хочу научиться рисовать"
            secondary
        />
    );
};
